const $ = require('jquery')
const Vue = require('vue')
let Mark = require('mark.js')

if (Mark.Mark) {
    Mark = Mark.Mark
}

const R = require('ramda')

const tagsModalTemplate = require('templates/ui-tags-modal.html')

Vue.component('tags-modal', {
    name: 'tags-modal',
    template: tagsModalTemplate,
    props: {
        alerts: {
            type: Array
        },
        placeholder: {
            type: String,
            default: null
        },
        tooltip: {
            type: String
        },
        model: {
            twoWay: true,
            type: Array,
            default () {
                return []
            }
        },
        groups: {
            type: Array,
            default () {
                return []
            }
        },
        options: {
            type: Array,
            default () {
                return []
            }
        },
        display: {
            type: String,
            default: 'name'
        },
        identifier: {
            type: String,
            default: 'id'
        },
        allowEmpty: {
            type: [Number, Boolean],
            default: false
        },
        onChange: {
            type: Function,
            default: null
        },
        itemName: {
            type: String,
            default: 'Valores'
        },
        maxItems: {
            type: Number,
            default: Infinity
        },
        mark: {
            type: Boolean,
            default: false
        },
        primaryButtonName: {
            type: String,
            default: 'Adicionar'
        },
        transform: {
            type: Function,
            default: null
        }
    },
    components: {
        ItemSelector: {
            name: 'item-selector',
            props: {
                options: {
                    type: Array,
                    default () {
                        return []
                    }
                },
                display: {
                    type: String,
                    default: 'name'
                },
                identifier: {
                    type: String,
                    default: 'id'
                },
                itemChecked: {
                    type: Function
                },
                isChecked: {
                    type: Function
                },
                tooltip: {
                    type:String
                },
                transform: {
                    type: Function,
                    default: null
                }
            },
            methods: {
                displayItem (item) {
                    if (this.transform) {
                        return this.transform(item)
                    }

                    return item[this.display]
                },
                identifyItem (item) {
                    return item[this.identifier]
                },
                tooltipItem (item) {
                    return item[this.tooltip]
                },
            },
            template: `
                <div class="col-xs-4" v-for="item in options" style="padding: 5px 0px">
                    <label>
                        <input type="checkbox" v-uniform="isChecked(item)"
                               v-on:change.prevent="itemChecked(item)" name="ui-tags-modal-checkbox"/>
                        <span data-toggle="tooltip" style="color: #000; font-weight: normal;" v-tooltip :vtitle="tooltipItem(item)">
                            {{{ displayItem(item) }}}
                        </span>
                    </label>
                </div>
            `
        }
    },
    data () {
        return {
            filteredOptions: [],
            filter: '',
            isVisible: false,
            counter: 0,
            tempModel: []
        }
    },
    ready () {
        if (this.groups.length > 0) {
            this.options = this.unnestGroups(this.groups)
        }

        this.merge()
        this.filterItems()
        this.loadItems()
    },
    watch: {
        model () {
            this.merge()
            this.filterItems()
            this.loadItems()
        },
        options () {
            this.filterItems()
        },
        filter () {
            this.filterItems()
        },
        groups () {
            this.options = this.unnestGroups(this.groups)
        }
    },
    methods: {
        unnestGroups (groups, all = []) {
            return groups.reduce((all, current) => {
                return all.concat(current.options)
            }, all)
        },
        merge () {
            if (Array.isArray(this.model)) {
                this.model.forEach(item => {
                    if (!R.any(_ => _.id === item.id, this.options)) {
                        this.options.push(item)
                    }
                })
            }
        },
        loadItems () {
            this.shadowModel = this.model.map(item => this.identifyItem(item))
            this.tempModel = this.model.map(item => this.identifyItem(item))
        },
        displayItem (item) {
            return item[this.display]
        },
        identifyItem (item) {
            return item[this.identifier]
        },
        showModal () {
            this.loadItems()
            this.isVisible = true
            this.filter = ''

            Vue.nextTick(() => {
                const $root = $(this.$el)
                const $modal = $root.find('.modal')

                this.$mark = new Mark($('.items-holder', $modal).get(0))

                $modal.find('.items-holder').slimScroll({
                    height: '400px'
                })

                $modal
                    .on('shown.bs.modal', () => {
                        $modal.find('.search-box').focus()
                    })
                    .on('hidden.bs.modal', () => {
                        this.isVisible = false
                    })
                    .modal()
            })
        },
        itemChecked (item) {
            if (this.tempModel.indexOf(this.identifyItem(item)) > -1) {
                this.tempModel.$remove(this.identifyItem(item))
            } else {
                this.tempModel.push(this.identifyItem(item))
            }
        },
        isChecked (item) {
            return this.tempModel.indexOf(this.identifyItem(item)) > -1
        },
        getName (item) {
            return item[this.display].toLowerCase()
        },
        filterItems (event) {
            const value = this.filter.toLowerCase()

            const items = this.options.filter(_ => this.getName(_).indexOf(value) > -1)
            this.filteredOptions = items.slice(0, this.maxItems)
            this.counter = items.length - this.maxItems

            if (this.mark && this.$mark) {
                this.$mark.unmark().mark(value)
            }
        },
        remove (item) {
            this.tempModel.$remove(this.identifyItem(item))
            this.save()
        },
        save () {
            const $root = $(this.$el)
            const $modal = $root.find('.modal')

            const added = this.tempModel.filter(_ => this.shadowModel.indexOf(_) === -1)
            const removed = this.shadowModel.filter(_ => this.tempModel.indexOf(_) === -1)

            this.model = this.fetch(this.tempModel)

            this.loadItems()

            // console.log(JSON.stringify({
            //    tempModel: this.tempModel,
            //    shadowModel: this.shadowModel,
            //    actual: this.fetch(Vue.util.extend([], this.tempModel)),
            //    added: this.fetch(added),
            //    removed: this.fetch(removed)
            // }, null, ' '));

            if (this.onChange) {
                this.onChange({
                    actual: this.fetch(Vue.util.extend([], this.tempModel)),
                    added: this.fetch(added),
                    removed: this.fetch(removed)
                })
            }

            $modal.modal('hide')
        },
        fetch (items) {
            const newItems = items.map(item =>
                    ([item, R.head(
                        this
                            .options
                            .filter(_ => _.id === item)
                    )])
                )
                .filter(_ => !!_)

            const [ok] = R.partition(_ => !!_[1], newItems)

            return R.map(R.prop(1), ok)
        },
        filterOptions (options) {
            const value = this.filter.toLowerCase()

            return options.filter(_ => this.getName(_).indexOf(value) > -1)
        },
        filterGroupOptions (group) {
            const value = this.filter.toLowerCase()

            if (group.name.toLowerCase().indexOf(value) > -1) {
                return group.options
            } else {
                return group.options.filter(_ => this.getName(_).indexOf(value) > -1)
            }
        }
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/tags-modal.js